import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

const getAjaxUrl = "/webshop/step/get";
const setAjaxUrl = "/webshop/step/set";

export default new Vuex.Store({
    state: {
        isLoading: true,
        orderSteps: [],
        currentStep: 'Cart',
        userIsLogged: false,
        userData: [],
        productData: [],
        formData: [],
        orderData: [],
        languageData: [],
        settingData: [],
        errorData: [],
        orderSummaryData: [],
    },
    mutations: {
        setData(state, payload){
            if(payload.productData){
                state.productData = payload.productData;
            }

            if(payload.userData){
                state.userData = payload.userData;
            }

            if(payload.orderSummaryData){
                state.orderSummaryData = payload.orderSummaryData;
            }

            if(payload.errorData){
                state.errorData = payload.errorData;
            }
        },
        setIsLoading(state, payload) {
            state.isLoading = payload;
        },
        setOrderSteps(state, payload) {
            state.orderSteps = payload;
        },
        setCurrentStep(state, payload) {
            state.currentStep = payload;
        },
        setUserIsLogged(state, payload) {
            state.userIsLogged = payload;
        },
        setUserData(state, payload) {
            state.userData = payload;
        },
        setProductData(state, payload) {
            state.productData = payload;
        },
        setFormData(state, payload) {
            state.formData = payload;
        },
        setOrderData(state, payload) {
            state.orderData = payload;
        },
        setLanguageData(state, payload) {
            state.languageData = payload;
        },
        setSettingData(state, payload) {
            state.settingData = payload;
        },
        setOrderSummaryData(state, payload) {
            state.orderSummaryData = payload;
        },
        setErrorData(state, payload) {
            state.errorData = payload;
        },
    },
    actions: {
        setDefaultData(state) {
            fetch(getAjaxUrl, {
                Accept: "application/json"
            }).then(async response => {
                const data = await response.json();
                state.commit("setOrderSteps", data.orderSteps);
                state.commit("setUserIsLogged", data.userIsLogged);
                state.commit("setUserData", data.userData);
                state.commit("setProductData", data.productData);
                state.commit("setFormData", data.formData);
                state.commit("setOrderData", data.orderData);
                state.commit("setLanguageData", data.languageData);
                state.commit("setSettingData", data.settingData);
                state.commit("setErrorData", data.errorData);
                state.commit("setOrderSummaryData", data.orderSummaryData);
                state.commit("setIsLoading", false);
            }).catch(error => {
                console.error("There was an error!", error);
            });
        },
        setData(state, formData){
            //state.commit("setIsLoading", true);
            axios({
                method: "post",
                url: setAjaxUrl,
                headers: {
                    'content-type' : 'application/json',
                    'x-csrf-token' : document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                data: formData
            }).then(response => {
                state.commit("setData", response.data);

                if(response.data.currentStep){
                    state.commit("setCurrentStep", response.data.currentStep)
                }

                if(response.data.orderData){
                    state.commit("setOrderData", response.data.orderData)
                }

            }).catch(e => {
                console.log(e);
            });
        },
        setProductQuantity(state,data){
            let productData = {...state.state.productData};
            productData.products[data.index].quantity = data.value;
            state.commit('setProductData',productData);
        }
    },
    modules: {},
    getters: {
        getIsLoading: state => state.isLoading,
        getOrderSteps: state => state.orderSteps,
        getCurrentStep: state => state.currentStep,
        getUserIsLogged: state => state.userIsLogged,
        getUserData: state => state.userData,
        getProductData: state => state.productData,
        getFormData: state => state.formData,
        getOrderData: state => state.orderData,
        getLanguageData: state => state.languageData,
        getSettingData: state => state.settingData,
        getOrderSummaryData: state => state.orderSummaryData,
        getErrorData: state => state.errorData,
    },
})
